export const cssContainerFbHeroProp = "container-fastbooking-hero-JS";
export const cssCollapsedHeaderSelectorProp = "collapsed-header-js";
export const cssSelector = "c-heroslider";

const heroslider = {
  props: {
    dynamicClass: ".c-heroslider.dynamicLoading",
    cssSelector: "c-heroslider",
    cssSelectorSwiper: ".swiper-wrapper[data-items-load]",
    cssInjectBreadcrumb: ".cmp-breadcrumb",
    cssContainerFbHeroProp: "container-fastbooking-hero-JS",
    cssCollapsedHeaderSelectorProp: "collapsed-header-js",
    cssStampSelector: "stamp-JS",
    cssSlide: "swiper-slide",
    cssCtaHeroSelector: "heroslider-cta-JS",
    nameAttr: "data-items-load",
    CtaHeroSlider: null,
    config: {
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      loopedSlides: 1,
      loop: false,
      grabCursor: true,
      wrapperClass: "swiper-wrapper",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
    $fastBookingWrapper: null,
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-heroslider.css", this.props.dynamicClass);

    const element = document.querySelector("." + this.props.cssSelector);

    if (element) {
      this.removeEmptySlides(element);
      bcl.u.swiper.init(document, this.props);
    }

    if (bcl.editMode || !element) {
      return;
    }

    this.processHeader(element);
    this.processInjectBreadCrumb(element);

    this.initUrbanHero(element);

    if (element.dataset.embedfastbooking == "true") {
      this.processInjectHero(element);
    }

    if (bcl.u.browser.isSafari() && document.querySelectorAll(".booking-JS").length > 0) {
      this.addClassOnlySafariBrowser(element);
    }
  },

  removeEmptySlides: function ($element) {
    const rootDom = $element.querySelector("." + this.props.config.wrapperClass);
    if (rootDom) {
      const items = rootDom.querySelectorAll("." + this.props.cssSlide + " > DIV");
      bcl.u.forEach(items, function (elem) {
        if (elem.innerHTML.trim() === "") {
          rootDom.removeChild(elem.parentNode);
        }
      });
    }
  },

  processHeader: function ($element) {
    const header = document.querySelector("header");
    if (header) {
      let classes = "";
      if ($element.dataset.embedheader == "md" || $element.dataset.embedheader == "d") {
        classes += "c-container-collapsed-desktop ";
      }

      if ($element.dataset.embedheader == "md" || ($element.dataset.embedheader == "m" && bcl.u.mobile.isMobile())) {
        classes += "c-container-collapsed";
      }

      if (classes.length > 0) {
        bcl.u.addClass($element, "inject-header-true");
      }

      bcl.u.addClass(header, classes);
    }
  },

  processInjectBreadCrumb: function ($element, $node) {
    const $base = $node || document;
    const bc = $base.querySelector("main " + this.props.cssInjectBreadcrumb);
    if (bc) {
      const bcWrapper = bc.closest(".generic-container");
      if (bcWrapper) {
        bcl.u.addClass($element, "inject-breadcrumb-true");
        bcl.u.addClass(bcWrapper, "inject-breadcrumb");
        this.inject(bcWrapper, $element);
      }
    }
  },

  processInjectHero: function ($element) {
    const isTarget = this.globalEvent && this.globalEvent.props.isTarget;

    const fb = isTarget ? this.props.$fastBookingWrapper : document.querySelector(".c-fastbooking");
    if (!fb) {
      return;
    }

    const fbWrapper = fb.closest(".web-inherited-reference");
    if (!fbWrapper) {
      return;
    }

    const $container = $element.parentNode.getElementsByClassName("container-fastbooking-hero-JS");
    const $newServicesPage = document.querySelector(".mod--new-services");

    if ($container && $container[0] && !$newServicesPage) {
      bcl.u.addClass($element.parentNode, "inject-fastbooking-true");
      bcl.u.addClass(fbWrapper, "inject-fastbooking");
      this.props.$fastBookingWrapper = bcl.u.browser.IE() || bcl.u.browser.IE11() ? fbWrapper.cloneNode(true) : fbWrapper;
      this.inject(fbWrapper, $container[0]);
      if ((bcl.u.browser.IE() || bcl.u.browser.IE11()) && isTarget) {
        this.fastbooking.init();
        bcl.s.tabs.init();
        this.accordion.init();
      }
    }
  },
  initUrbanHero: function ($element) {
    const asyncObj = $element.querySelector(".js-c-heroslider-urban");
    if (asyncObj) {
      const dataInfo = asyncObj.getAttribute("data-items-load");
      if (dataInfo) {
        bcl.ajax.getRequest(asyncObj, dataInfo);
      }
    }
  },

  inject: function ($itemForInject, wrapper) {
    wrapper.appendChild($itemForInject);

    setTimeout(function () {
      const sw = document.querySelector(".c-heroslider__menu-wrapper");
      bcl.u.removeClass(sw, "opacity-0");
      bcl.u.addClass(sw, "opacity-100");
      bcl.u.addClass(sw, "common-transition");
    }, 1350);
  },

  addClassOnlySafariBrowser: function ($element) {
    const headHotel = document.getElementsByClassName(bcl.c.fastbooking.commonProps.fastbooking.selectors.headHotelSelector)[0];
    if ($element.classList.contains("inject-breadcrumb-true")) {
      if ($element.classList.contains("mod--layout-urban") || $element.classList.contains("mod--layout-vacational")) {
        bcl.u.addClass(headHotel, "hack--head-hotel-info");
      }
    }
  },
};

export default heroslider;
